"use strict";
require("src/decidim/voca/voca");
